import { useState, useEffect } from "react";
import { Outlet, useLocation, Navigate } from "react-router-dom";
// material
import { styled, ThemeProvider } from "@mui/material/styles";
//
// import DashboardNavbar from './DashboardNavbar';
import DashboardSidebar from "../../../../Layout/Dashboard/DashboardSidebar";
import DashboardNavbar from "../../../../Layout/Dashboard/DashboardNavbar";
import Preloader from "../../../../Components/Preloader/Preloader";
import { poppinsCustomTheme } from "../../../../Styles/GlobalStyles/PoppinsTheme";
import {
  fetchAllTotalSkillsData,
  fetchAllTotalTrainersDetails,
  fetchPartnerDashboardDetails,
  fetchTotalSkillCenterDetails,
} from "../../../../Actions";
import { useDispatch } from "react-redux";
import useResponsive from "../../../../Hooks/hooks";
// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 92;
const DRAWER_WIDTH = 280;

const RootStyle = styled("div")({
  display: "flex",
  minHeight: "100vh",
  overflow: "hidden",
  fontFamily: "Public Sans, san-serif !important ",
});

const Main = styled("div", { shouldForwardProp: (prop) => prop !== "open" })(
  ({ theme, open }) => ({
    flexGrow: 1,
    overflow: "auto",
    minHeight: "100%",
    paddingTop: APP_BAR_MOBILE + 24,
    paddingBottom: theme.spacing(10),
    background: "#F9FAFB",
    [theme.breakpoints.up("lg")]: {
      paddingTop: APP_BAR_DESKTOP + 24,
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: `-${DRAWER_WIDTH}px`,
    ...(!open && {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    }),
  })
);

const MainStyle = styled("div")(({ theme }) => ({
  flexGrow: 1,
  overflow: "auto",
  minHeight: "100%",
  paddingTop: APP_BAR_MOBILE + 24,
  paddingBottom: theme.spacing(10),
  background: "#F9FAFB",
  [theme.breakpoints.up("lg")]: {
    paddingTop: APP_BAR_DESKTOP + 24,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));

// ----------------------------------------------------------------------

export default function HomeLayout() {
  const isDesktop = useResponsive("up", "lg");

  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const user = JSON.parse(localStorage.getItem('user'))

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 2000);
    if (loading === false && user.role === 'SAED_NDHQ') {
      dispatch(fetchAllTotalSkillsData());
      dispatch(fetchAllTotalTrainersDetails());
      dispatch(fetchPartnerDashboardDetails());
      dispatch(fetchTotalSkillCenterDetails());
    }
  }, [loading, dispatch]);

  const location = useLocation();
  if (location.pathname === "/home") {
    return <Navigate to="/home/dashboard" replace />;
  }

  return (
    <>
      {loading === true ? (
        <Preloader />
      ) : (
        <ThemeProvider theme={poppinsCustomTheme}>
          {isDesktop && (
            <RootStyle>
              <DashboardNavbar
                isOpenSidebar={!open}
                onOpenSidebar={() => setOpen(!open)}
              />
              <DashboardSidebar
                isOpenSidebar={open}
                onCloseSidebar={() => setOpen(!open)}
              />
              <Main open={open}>
                <Outlet />
              </Main>
            </RootStyle>
          )}

          {!isDesktop && (
            <RootStyle>
              <DashboardNavbar
                // isOpenSidebar={open}
                onOpenSidebar={() => setOpen(true)}
              />
              <DashboardSidebar
                isOpenSidebar={open}
                onCloseSidebar={() => setOpen(false)}
              />
              <MainStyle>
                <Outlet />
              </MainStyle>
            </RootStyle>
          )}
        </ThemeProvider>
      )}
    </>
  );
}
